import { faImage } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router';
import { NoItemsAlert } from '~/components/common/NoItemsAlert';
import { PublishedContainer } from '~/components/common/published-container';
import { useShowUnpublished } from '~/components/upload/supporting-object/use-show-unpublished';
import { panelDetailRoute } from '~/paths';
import { useOutcropPanelsOutletContext } from '~/routes/outcrop/$outcropId/panels';
import {
  countUnpublishedItems,
  isPublished,
} from '~/utils/modules/supporting-object';

export default function OutcropPanelsIndexPage() {
  const ctx = useOutcropPanelsOutletContext();

  const { showUnpublished, PublishedToggle } = useShowUnpublished(
    countUnpublishedItems(ctx.panels),
  );

  const panels = ctx.panels.filter(p => showUnpublished || isPublished(p));

  return (
    <div className="space-y-4">
      <PublishedToggle />
      <NoItemsAlert show={!panels.length} entity="panels" />

      {panels.map(panel => (
        <PublishedContainer key={panel.id} published={isPublished(panel)}>
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="card-title">{panel.name}</h2>
              <div>Author: {panel.author}</div>
              <div>{panel.description}</div>
            </div>

            <figure>
              <Link
                to={panelDetailRoute(ctx.outcropId, parseInt(panel.id))}
                className="w-full h-72 relative overflow-hidden hover:border-2 hover:border-primary"
              >
                {panel.originalPanel ? (
                  <img
                    src={panel.originalPanel.pictureUrl}
                    className="absolute inset-0 w-full h-full object-cover"
                    alt="panel thumbnail"
                  />
                ) : (
                  <div className="w-full h-full bg-slate-50 flex justify-center items-center">
                    <FontAwesomeIcon icon={faImage} className="text-3xl" />
                  </div>
                )}
              </Link>
            </figure>
          </div>
        </PublishedContainer>
      ))}
    </div>
  );
}
